import React from 'react';
import Plot from 'react-plotly.js';

const DelayExamples = () => {
    const data = [
    {
      reactor: "Flamanville-3",
      est_time: 5,
      actual_time: 17,
      hover: `Flamanville-3<br>
Start: 2007<br>
Est: ~2012<br>
Fuel: May 2024<br>
Grid: Dec 2024<br>
Est Time: ~4½ yrs<br>
Actual Time: ~15½ yrs<br>
Cost: Initial $3.8B → Final $13.7B`
    },
    {
      reactor: "Olkiluoto-3",
      est_time: 4,
      actual_time: 18,
      hover: `Olkiluoto-3<br>
Start: 2005<br>
Est: ~2009<br>
Commercial: Apr 2023<br>
Est Time: ~4 yrs<br>
Actual Time: ~18 yrs<br>
Cost: Initial $3.5B → Final $12B`
    },
    {
      reactor: "Vogtle Unit 3",
      est_time: 3,
      actual_time: 10.5,
      hover: `Vogtle Unit 3<br>
Start: 2013<br>
Est: 2016<br>
Fuel: Jul 31 2023<br>
Est Time: ~3 yrs<br>
Actual Time: ~10½ yrs<br>
Cost: Initial $14B → Final $30B (shared w/ Unit 4)`
    },
    {
      reactor: "Vogtle Unit 4",
      est_time: 4,
      actual_time: 10.5,
      hover: `Vogtle Unit 4<br>
Start: ~late 2013<br>
Est: 2017<br>
Fuel: Apr 29 2024<br>
Est Time: ~4 yrs<br>
Actual Time: ~10½ yrs<br>
Cost: Initial $14B → Final $30B (shared w/ Unit 3)`
    },
    {
      reactor: "Hinkley Point C Unit 1",
      est_time: 8,
      actual_time: 13,
      hover: `Hinkley Point C (Unit 1)<br>
Start: Mar 2017<br>
Est: ~2025<br>
Grid: 2029-31<br>
Est Time: ~8 yrs<br>
Actual Time: ~12-14 yrs<br>
Cost: Initial $35B → Final $47B`
    },
    {
      reactor: "Taishan Unit 1",
      est_time: 3.8,
      actual_time: 7.3,
      hover: `Taishan Unit 1<br>
Start: Oct 2009<br>
Est: ~4 yrs<br>
Fuel: mid-2018<br>
Est Time: ~3.8 yrs<br>
Actual Time: ~7.3 yrs<br>
Cost: Initial $7.5B → Final $15B`
    },
    
  ];

  const reactors = data.map(d => d.reactor);

  const estimated = {
    x: reactors,
    y: data.map(d => d.est_time),
    name: 'Estimated Time',
    type: 'bar',
    marker: { color: 'red' },
    hovertext: data.map(d => d.hover),
    hoverinfo: 'text'
  };

  const actual = {
    x: reactors,
    y: data.map(d => d.actual_time - d.est_time),
    name: 'Actual Time',
    type: 'bar',
    marker: { color: 'orange' },
    hovertext: data.map(d => d.hover),
    hoverinfo: 'text'
  };

  const layout = {
    barmode: 'stack',
    title: 'Estimated vs Actual Nuclear Reactor Build Time',
    xaxis: { title: 'Reactor', fixedrange:true },
    yaxis: { title: 'Time to Completion (years)', fixedrange:true },
    legend: { title: { text: 'Time Type' } },
    margin: { t: 50, l: 50, r: 30, b: 80 }
  };

  return (
    <div>
      <h2>Delay Examples</h2>
      <Plot 
      data={[estimated, actual]} 
      layout={layout} 
      style={{ width: "100%", height: "100%" }} 
      
      config={{ displayModeBar: false, scrollZoom: false }}
      />
    </div>
  );
};

export default DelayExamples;
